import { c as _c } from "react/compiler-runtime";
import { useClipboard } from 'foxact/use-clipboard';
import ms from 'ms';
import type { Sentence } from '@/app/[locale]/(vocabulary)/_lib/LexiconTrie';
import type { WordOccurrencesInSentence } from '@/app/[locale]/(vocabulary)/_lib/vocab';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
function SentenceCopy(t0) {
  const $ = _c(24);
  const {
    sentence
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      timeout: ms("1s")
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    copy,
    copied,
    error
  } = useClipboard(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("inline-flex size-(--leading) h-[unset] items-start p-0");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== copy || $[3] !== sentence) {
    t3 = () => copy(sentence);
    $[2] = copy;
    $[3] = sentence;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = copied ? "" : "hidden";
  let t5;
  if ($[5] !== t4) {
    t5 = cn("icon-[mingcute--check-fill]", t4);
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <svg className={t5} />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = error ? "" : "hidden";
  let t8;
  if ($[9] !== t7) {
    t8 = cn("icon-[bx--bxs-error-circle] text-red-500", t7);
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <svg className={t8} />;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = copied || error ? "hidden" : "";
  let t11;
  if ($[13] !== t10) {
    t11 = cn("icon-[ooui--copy-ltr] opacity-0 transition-opacity delay-50 duration-100 in-data-[state=open]:group-hover:opacity-100", t10);
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11) {
    t12 = <svg className={t11} />;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t12 || $[18] !== t6 || $[19] !== t9) {
    t13 = <div className="flex size-(--leading) items-center justify-center *:size-2.75!">{t6}{t9}{t12}</div>;
    $[17] = t12;
    $[18] = t6;
    $[19] = t9;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13 || $[22] !== t3) {
    t14 = <Button variant="ghost" className={t2} onClick={t3}>{t13}</Button>;
    $[21] = t13;
    $[22] = t3;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
}
export function ExampleSentence(t0) {
  const $ = _c(12);
  const {
    sentences,
    wordOccurrences,
    className: t1,
    onSentenceTrack
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("mr-3 mb-1 ml-2 flex flex-col gap-[.5px] text-[.8125rem] leading-(--leading) text-neutral-600 [--leading:1.125rem]", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onSentenceTrack || $[3] !== sentences || $[4] !== wordOccurrences) {
    let t4;
    if ($[6] !== onSentenceTrack || $[7] !== sentences) {
      t4 = t5 => {
        const {
          sentenceId,
          textSpans
        } = t5;
        let progress = 0;
        const sentence = sentences[sentenceId]?.text ?? "";
        return <div key={sentenceId} className="group flex items-stretch gap-1 wrap-break-word [word-break:break-word] transition-colors duration-150 hover:text-black dark:text-neutral-500 dark:hover:text-neutral-300"><Button variant="ghost" className="flex h-auto min-w-(--leading) items-start p-0 opacity-0 transition-opacity delay-50 duration-100 in-data-[state=open]:group-hover:opacity-100" onClick={() => onSentenceTrack(sentenceId)}><div className="flex size-(--leading) items-center justify-center pl-[.5px]"><svg className="icon-[iconamoon--arrow-right-1-bold] size-2.75" /></div></Button><div>{textSpans.map(t6 => {
              const {
                startOffset,
                wordLength
              } = t6;
              const oldProgress = progress;
              progress = startOffset + wordLength;
              return <span key={startOffset}><span>{sentence.slice(oldProgress, startOffset)}</span><span className="text-black underline underline-offset-[.145em] dark:text-neutral-300">{sentence.slice(startOffset, progress)}</span></span>;
            })}<span>{sentence.slice(progress)}</span><div className="inline-flex h-lh items-center justify-center pl-1 align-bottom"><SentenceCopy sentence={sentence} /></div></div></div>;
      };
      $[6] = onSentenceTrack;
      $[7] = sentences;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = wordOccurrences.map(t4);
    $[2] = onSentenceTrack;
    $[3] = sentences;
    $[4] = wordOccurrences;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}